module.exports = __webpack_public_path__ + "assets/img/Russian-btn.6e859522.png";